import getRecordSelector from 'root/src/client/logic/api/selectors/getRecordSelector'
import propOr from 'ramda/src/propOr'

export default (state, props) => propOr(undefined, 'image', getRecordSelector(state, props))
